import React from 'react'
import Fragment from '../common/fragment'


function FragmentBZ(props) {
  return (
    <Fragment pos="zz" {...props}>
      <p>
A los sacerdotes aztecas los pintaban de negro al amanecer. Todo el cuerpo en el
templo, unos niños.
      </p>
    </Fragment>
  )
}


export default FragmentBZ
